import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const ContentHome = () => {
	const location = useLocation()

	const [render, setRender] = useState<stateComponentComplete>({ ready: false })
	useEffect(() => {
		if (render.ready) sendDataLayer('onload-home', location.pathname)
		setRender({ ready: true })
	}, [location.pathname, render.ready])
	return (
		<main className='container_content'>
			<section className='container_text'>
				<p className='text_principal'>
					En Profuturo te asesoramos para asegurar tu bienestar financiero en todas
					las etapas de tu vida. <br />
				</p>
				<p className='text_principal text_principal-2'>¿En qué podemos ayudarte?</p>
			</section>
			<section className='container_options'>
				<div
					onClick={() => {
						sendDataLayer('click-link-afore', location.pathname)
					}}
					className='option option_1'
				>
						<div className='container_img'>
							<img
								src='https://registrate.profuturo.mx/rs/117-UEL-823/images/marca_option_1.jpg'
								alt='Afore'
								className='img img-options img-1'
							/>
							<div className='button'>Afore</div>
						</div>
				</div>
				<div
					onClick={() => {
						sendDataLayer('click-link-pensiones', location.pathname)
					}}
					className='option option_2'
				>
					<a
						href='https://www.profuturo.mx/pensionespublico/wps/portal/ContentHome/Pensiones'
						target='_blank'
						rel='noreferrer'
					>
						<div className='container_img'>
							<img
								src='https://registrate.profuturo.mx/rs/117-UEL-823/images/marca_option_2.jpg'
								alt='Prestamos'
								className='img img-options img-2'
							/>
							<div className='button'>Pensiones</div>
						</div>
					</a>
				</div>
			</section>
		</main>
	)
}

export default ContentHome
